/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CapNames, Director, MaterialType,
   Stage, DefaultCaps, Materials, Solids, StageDesc, DefaultNavigators } from '@sick-davinci/glow';
import { MixOperation, DoubleSide, Mesh } from 'three';

/**
 * Demo:    SkyBox
 * Description:
 *  This demo application displays a skybox based on 6 faces / images of a cube.
 * Features:
 *  - Orbit navigation
 *  - Capability handling
 *  - Skybox capability
 */
export const run = ((viewParent: HTMLElement) => {

  // ** setup screen *
  const setup: StageDesc = {
    cameras: [
      {
        name: 'frontCamera',
        from: [30, 30, 10],
        to: [0, 0, 0],
        up: [0, 1, 0],
        fov: 90,
      },
    ],
    scenes: [
      { name: 'default' },
    ],
    viewports: [
      {
        scene: 'default',
        camera: 'frontCamera',
        navigator: 'orbit',
        left: 0,
        top: 0,
        width: 1.0,
        height: 1.0,
        bgcolor: 0x888800,
      },
    ],
  };

  const stage = new Stage(viewParent, setup);

  // * Add an Orbit Navigator
  DefaultNavigators.initOrbit(stage, 'orbit');
  stage.start(); // start visualization

  // ** data handling using capabilities
  const director = new Director(stage);
  DefaultCaps.init(director);
  director.handle(CapNames.SKYBOX, {
    textureList: [
      './resources/face-r.jpg',
      './resources/face-l.jpg',
      './resources/face-t.jpg',
      './resources/face-d.jpg',
      './resources/face-f.jpg',
      './resources/face-b.jpg',
    ],
  });

  director.handle(CapNames.LIGHT, { lightType: 'ambient', color: 0xdddddd });

  // * Add a reflecting Sphere using native threejs code
  stage.applyThreeDirect((scene) => {
    const material = Materials.create({ type: MaterialType.lambert, useBackground: true, params: { color: 0x0000ff, combine: MixOperation, reflectivity: 0.9 } }, scene);
    material.side = DoubleSide;
    const solid = new Mesh(Solids.createSphere(10, 100, 100), material);
    solid.name = 'Sphere';

    scene.set(solid);
  });
});
